import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '合集库', to: '/collections' },
  { label: '分类', to: '/collections#categories' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav
        className="w-full flex items-center justify-between px-4 md:px-10 h-16 md:h-20"
        aria-label="主导航"
      >
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-bold text-lg md:text-xl text-foreground-950 tracking-wide">
              看瓜爆料
            </span>
            <span className="text-[10px] md:text-[11px] text-foreground-600 tracking-[0.2em] label-font">
              合集汇总专题
            </span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm label-font transition-colors whitespace-nowrap ${
                  isActive && item.to !== '/collections#categories'
                    ? 'text-primary-700 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-700 hover:bg-background-100'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="/collections"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-foreground-900 text-background-50 text-sm label-font whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-search-line"></i>
            找专题
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-900"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-3 flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="py-3 text-sm label-font text-foreground-800 border-b border-background-100 last:border-0"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/collections"
              className="mt-3 inline-flex items-center justify-center gap-2 py-3 rounded-md bg-primary-500 text-background-50 text-sm label-font"
            >
              <i className="ri-search-line"></i>
              去合集库找专题
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}